import React from "react";
import styles from "./Rollo.module.css";

interface IRolloProps {
  index: number;
  value: string;
  onClick: (e: any, selectedRolloId: any) => void;
}
const Rollo = (props: IRolloProps) => {
  const { index, value, onClick } = props;

  return (
    <li className={styles["list-item-rollo"]}>
      {value ? (
        <span className={styles["rollo-id-label"]}>#{index + 1}</span>
      ) : (
        ""
      )}
      <span
        className={`${styles.cursor_pointer} badge ${styles.badge_rollo} ${
          value
            ? "text-bg-warning"
            : `text-bg-secondary ${styles["badge-placeholder"]}`
        }`}
        onClick={(e) => {
          onClick(e, index);
        }}
      >
        {value ? value : `Agregar rollo #${index + 1}...`}
      </span>
    </li>
  );
};

export default Rollo;
